<!-- NavBar.vue -->
<template>
  <header 
    :class="[
      'fixed top-0 left-0 right-0 z-50 transition-all duration-500',
      isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
    ]"
  >
    <div class="max-w-7xl mx-auto px-6">
      <!-- Initial Layout (Centered Logo, Stacked) -->
      <div 
        v-if="!isScrolled"
        class="py-6 transition-all duration-500"
      >
        <!-- Centered Logo -->
        <div class="flex justify-center items-center mb-6">
          <img src="../assets/icons/hutu-abuja.png" alt="" class="h-16">
        </div>

        <!-- Navigation and Buttons (Centered Below Logo) -->
        <div class="flex flex-col items-center gap-6">
          <!-- Desktop Navigation -->
          <nav class="hidden lg:flex items-center gap-8">
            <router-link to="/" class="relative text-white hover:text-yellow-500 transition-colors font-medium group">
              <span>Home</span>
              <span class="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-yellow-400 to-yellow-600 transition-all duration-300 group-hover:w-full router-link-active:w-full"></span>
            </router-link>
            <router-link to="/about" class="relative text-white hover:text-yellow-500 transition-colors font-medium group">
              <span>About</span>
              <span class="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-yellow-400 to-yellow-600 transition-all duration-300 group-hover:w-full router-link-active:w-full"></span>
            </router-link>
            <router-link to="/services" class="relative text-white hover:text-yellow-500 transition-colors font-medium group">
              <span>Services</span>
              <span class="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-yellow-400 to-yellow-600 transition-all duration-300 group-hover:w-full router-link-active:w-full"></span>
            </router-link>
            <router-link to="/projects" class="relative text-white hover:text-yellow-500 transition-colors font-medium group">
              <span>Projects</span>
              <span class="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-yellow-400 to-yellow-600 transition-all duration-300 group-hover:w-full router-link-active:w-full"></span>
            </router-link>
            <router-link to="/contact" class="relative text-white hover:text-yellow-500 transition-colors font-medium group">
              <span>Contact</span>
              <span class="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-yellow-400 to-yellow-600 transition-all duration-300 group-hover:w-full router-link-active:w-full"></span>
            </router-link>
          </nav>

          <!-- CTA Buttons -->

          <!-- Mobile Menu Button -->
          <button 
            @click="toggleMenu"
            class="lg:hidden text-white p-2"
          >
            <svg v-if="!isMenuOpen" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
            <svg v-else class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      <!-- Scrolled Layout (Horizontal, Single Row) -->
      <div 
        v-else
        class="py-4 transition-all duration-500"
      >
        <div class="flex justify-between items-center">
          <!-- Logo -->
          <img src="../assets/icons/hutu-black.png" alt="" class="h-10">

          <!-- Desktop Navigation -->
          <nav class="hidden lg:flex items-center gap-8">
            <router-link to="/" class="relative text-gray-900 hover:text-yellow-600 transition-colors font-medium group">
              <span>Home</span>
              <span class="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-yellow-400 to-yellow-600 transition-all duration-300 group-hover:w-full router-link-active:w-full"></span>
            </router-link>
            <router-link to="/about" class="relative text-gray-900 hover:text-yellow-600 transition-colors font-medium group">
              <span>About</span>
              <span class="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-yellow-400 to-yellow-600 transition-all duration-300 group-hover:w-full router-link-active:w-full"></span>
            </router-link>
            <router-link to="/services" class="relative text-gray-900 hover:text-yellow-600 transition-colors font-medium group">
              <span>Services</span>
              <span class="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-yellow-400 to-yellow-600 transition-all duration-300 group-hover:w-full router-link-active:w-full"></span>
            </router-link>
            <router-link to="/projects" class="relative text-gray-900 hover:text-yellow-600 transition-colors font-medium group">
              <span>Projects</span>
              <span class="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-yellow-400 to-yellow-600 transition-all duration-300 group-hover:w-full router-link-active:w-full"></span>
            </router-link>
            <router-link to="/contact" class="relative text-gray-900 hover:text-yellow-600 transition-colors font-medium group">
              <span>Contact</span>
              <span class="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-yellow-400 to-yellow-600 transition-all duration-300 group-hover:w-full router-link-active:w-full"></span>
            </router-link>
          </nav>

          <!-- CTA Buttons -->
          <div class="hidden lg:flex items-center gap-4">
            <button class="px-6 py-2.5 bg-gradient-to-r from-yellow-500 to-yellow-600 text-main_black rounded-full font-semibold hover:shadow-lg hover:shadow-yellow-500/50 transition-all duration-300">
              Let's Talk
            </button>
          </div>

          <!-- Mobile Menu Button -->
          <button 
            @click="toggleMenu"
            class="lg:hidden text-gray-900 p-2"
          >
            <svg v-if="!isMenuOpen" class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
            <svg v-else class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      <!-- Mobile Menu -->
      <transition name="slide">
        <div 
          v-if="isMenuOpen" 
          :class="[
            'lg:hidden border-t py-6 px-6',
            isScrolled ? 'bg-white border-yellow-500/20' : 'bg-black/95 backdrop-blur-lg border-yellow-500/20'
          ]"
        >
          <nav class="flex flex-col gap-4">
            <router-link 
              to="/" 
              @click="toggleMenu" 
              :class="[
                'transition-colors py-2 relative pl-4',
                isScrolled ? 'text-gray-900 hover:text-yellow-600' : 'text-white hover:text-yellow-500'
              ]"
            >
              <span class="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-0 bg-gradient-to-b from-yellow-400 to-yellow-600 transition-all duration-300 router-link-active:h-full"></span>
              Home
            </router-link>
            <router-link 
              to="/about" 
              @click="toggleMenu" 
              :class="[
                'transition-colors py-2 relative pl-4',
                isScrolled ? 'text-gray-900 hover:text-yellow-600' : 'text-white hover:text-yellow-500'
              ]"
            >
              <span class="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-0 bg-gradient-to-b from-yellow-400 to-yellow-600 transition-all duration-300 router-link-active:h-full"></span>
              About
            </router-link>
            <router-link 
              to="/services" 
              @click="toggleMenu" 
              :class="[
                'transition-colors py-2 relative pl-4',
                isScrolled ? 'text-gray-900 hover:text-yellow-600' : 'text-white hover:text-yellow-500'
              ]"
            >
              <span class="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-0 bg-gradient-to-b from-yellow-400 to-yellow-600 transition-all duration-300 router-link-active:h-full"></span>
              Services
            </router-link>
            <router-link 
              to="/projects" 
              @click="toggleMenu" 
              :class="[
                'transition-colors py-2 relative pl-4',
                isScrolled ? 'text-gray-900 hover:text-yellow-600' : 'text-white hover:text-yellow-500'
              ]"
            >
              <span class="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-0 bg-gradient-to-b from-yellow-400 to-yellow-600 transition-all duration-300 router-link-active:h-full"></span>
              Projects
            </router-link>
            <router-link 
              to="/contact" 
              @click="toggleMenu" 
              :class="[
                'transition-colors py-2 relative pl-4',
                isScrolled ? 'text-gray-900 hover:text-yellow-600' : 'text-white hover:text-yellow-500'
              ]"
            >
              <span class="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-0 bg-gradient-to-b from-yellow-400 to-yellow-600 transition-all duration-300 router-link-active:h-full"></span>
              Contact
            </router-link>
            <div class="flex flex-col gap-3 pt-4 border-t border-yellow-500/20">
              <button class="px-6 py-2.5 text-gray-900 border-2 border-yellow-500 rounded-full hover:bg-yellow-500 hover:text-black transition-all">
                Login
              </button>
              <button class="px-6 py-2.5 bg-gradient-to-r from-yellow-500 to-yellow-600 text-black rounded-full font-semibold">
                Let's Talk
              </button>
            </div>
          </nav>
        </div>
      </transition>
    </div>
  </header>
</template>

<script>
export default {
  name: 'NavBar',
  data() {
    return {
      isMenuOpen: false,
      isScrolled: false
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 100;
      // Close mobile menu when scrolling
      if (this.isScrolled && this.isMenuOpen) {
        this.isMenuOpen = false;
      }
    }
  }
};
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}

.slide-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* Active Link Styles */
.router-link-active {
  color: #eab308 !important; /* yellow-500 */
}

.router-link-active span {
  width: 100% !important;
}

.router-link-active.relative.pl-4 span {
  height: 100% !important;
  width: 0.25rem !important;
}
</style>